import { createSlice } from "@reduxjs/toolkit";
import update from "immutability-helper";
import {
  fetchIstitutiScolasticiSuccess,
  fetchIstitutiScolasticiFailed,
  fetchIncarichiSuccess,
  fetchIncarichiFailed,
  fetchProfiloSuccess,
  inserisciProfilo,
  aggiornaProfilo,
  inserimentoProfiloFailed,
} from "./index";

export const initialState = {
  profilo: null,
  inserimentoCompletato: null,
  istituti: {
    data: [],
    fetchEnded: false,
  },
  incarichi: {
    data: [],
    fetchEnded: false,
  },
};

const fetchProfiloSuccessHandler = (state, action) => {
  return update(state, {
    profilo: { $set: action.payload },
  });
};

const inserisciProfiloHandler = (state) => {
  return update(state, {
    inserimentoCompletato: { $set: initialState.inserimentoCompletato },
  });
};

const inserimentoProfiloFailedHandler = (state) => {
  return update(state, {
    inserimentoCompletato: { $set: true },
  });
};

const fetchIstitutiScolasticiSuccessHandler = (state, action) => {
  return update(state, {
    istituti: {
      data: { $set: action.payload },
      fetchEnded: { $set: true },
    },
  });
};

const fetchIstitutiScolasticiFailedHandler = (state) => {
  return update(state, {
    istituti: {
      fetchEnded: { $set: true },
    },
  });
};

const fetchIncarichiSuccessHandler = (state, action) => {
  return update(state, {
    incarichi: {
      data: { $set: action.payload },
      fetchEnded: { $set: true },
    },
  });
};

const fetchIncarichiFailedHandler = (state) => {
  return update(state, {
    incarichi: {
      fetchEnded: { $set: true },
    },
  });
};

const osservatorioSlice = createSlice({
  name: "osservatorio",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchProfiloSuccess, (state, action) => fetchProfiloSuccessHandler(state, action));
    builder.addCase(inserisciProfilo, (state) => inserisciProfiloHandler(state));
    builder.addCase(aggiornaProfilo, (state) => inserisciProfiloHandler(state));
    builder.addCase(inserimentoProfiloFailed, (state) => inserimentoProfiloFailedHandler(state));
    builder.addCase(fetchIstitutiScolasticiSuccess, (state, action) => fetchIstitutiScolasticiSuccessHandler(state, action));
    builder.addCase(fetchIstitutiScolasticiFailed, (state) => fetchIstitutiScolasticiFailedHandler(state));
    builder.addCase(fetchIncarichiSuccess, (state, action) => fetchIncarichiSuccessHandler(state, action));
    builder.addCase(fetchIncarichiFailed, (state) => fetchIncarichiFailedHandler(state));
  },
});

export const osservatorioReducer = osservatorioSlice.reducer;
